var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"blank-overlay",attrs:{"show":_vm.showBackgroundOverlay,"no-wrap":"","opacity":"0.4","z-index":"1030","blur":"4px"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('span')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }